var _module_exports = "<img ng-if=\"$ctrl.facebookUserId\" ng-src=\"{{'https://graph.facebook.com/' + $ctrl.facebookUserId + '/picture?type=small'}}\"/>";;
var path = '/app/components/deal-sheet/facebook-photo.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;